import { Node } from './q-node';

export class Queue {
  constructor(public id: string, public head?: Node, public tail?: Node) {}

  public pop = (): any | void => {
    if (this.head) {
      const tempOut: Node | undefined = this.tail;
      this.tail = this.tail?.next;
      if (!tempOut?.value) {
        this.head = undefined;
      }
      return tempOut?.value;
    } else {
      return undefined;
    }
  };

  public insert = (node: Node): void => {
    if (this.head) {
      this.head.next = node;
      this.head = node;
    } else {
      this.head = node;
      this.tail = node;
    }
    // Pop clears the tail one call before it clears the head, so inserting right
    // after the last node was popped has to restore the tail, otherwise the new
    // node is unreachable and can never be popped again
    if (!this.tail) {
      this.tail = node;
    }
  };
}
